import Loadable from 'react-loadable';
export const LazyTeamsDisabled = Loadable({
  loader: () => import( /* webpackChunkName: "async-ptc_teams-disabled-page" */'./index').then(module => module.TeamsDisabled),
  loading: () => null
});
LazyTeamsDisabled.displayName = 'lazy(TeamsDisabled)';